"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Observable {
    constructor(value, observerCallback) {
        this.subscriptions = [];
        this._value = value;
        if (observerCallback !== undefined) {
            this.subscribe(observerCallback);
        }
    }
    get value() { return this._value; }
    set value(nextValue) {
        this._value = nextValue;
        this.notify();
    }
    subscribe(callback) {
        this.subscriptions.push(callback);
    }
    unsubscribe(callback) {
        // Remove subscription
        if (this.subscriptions.includes(callback)) {
            this.subscriptions.filter((subscription) => subscription === callback);
            return;
        }
    }
    notify() {
        this.subscriptions.forEach((subscription) => subscription(this._value));
    }
}
exports.Observable = Observable;
class ObservableFiniteStateMachine extends Observable {
    get state() { return this._value; }
    set state(nextValue) {
        this.value = nextValue;
    }
}
exports.default = ObservableFiniteStateMachine;
//# sourceMappingURL=ObservableFiniteStateMachine.js.map